import React from 'react';
const SWIFT_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/r1jdvZgvgzyfVGToCTCAe7/transparent_output.png';
export function Logo({
  className = '',
  size = 'default'
}: {
  className?: string;
  size?: 'default' | 'large' | 'small';
}) {
  const iconSize = size === 'large' ? 'h-12 w-12' : size === 'small' ? 'h-6 w-6' : 'h-10 w-10';
  const textSize = size === 'large' ? 'text-3xl' : size === 'small' ? 'text-xl' : 'text-2xl';
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-169">
      <img src={SWIFT_LOGO_URL} alt="enSwift logo" className={`${iconSize} object-contain`} data-id="element-170" />
      <div className="flex items-baseline gap-2" data-id="element-171">
        <div className={`font-bold ${textSize} tracking-tight`} data-id="element-172">
          <span className="text-brand-green" data-id="element-173">en</span>
          <span className="text-brand-teal" data-id="element-174">Swift</span>
        </div>
        {size !== 'small' && <span className="text-xs font-medium text-slate-400 hidden sm:inline-block" data-id="element-175">
            by EnMedical Systems
          </span>}
      </div>
    </div>;
}
export { SWIFT_LOGO_URL };